import { Action } from '@ngrx/store';
import { TOrderAttributesInfoActionType } from './order-attributes.models';
import {
  TOrderAttributeTypes,
  TREQUEST_ADD_UPDATE_ORDER_ATTRIBUTES,
  TREQUEST_DELETE_ORDER_ATTRIBUTES,
  TREQUEST_ORDER_ATTRIBUTES,
  TRESPONSE_ORDER_ATTRIBUTES,
} from '@monorepo/types';
import { TLiftedFormModel } from '@monorepo/ui';

export class GetOrderAttributesInfo implements Action {
  readonly type = TOrderAttributesInfoActionType.GetOrderAttributes;
  constructor(public payload: TREQUEST_ORDER_ATTRIBUTES) {}
}

export class GetOrderAttributesInfoSuccess implements Action {
  readonly type = TOrderAttributesInfoActionType.GetOrderAttributesSuccess;
  constructor(public OrderAttributesRes: TRESPONSE_ORDER_ATTRIBUTES) {}
}

export class GetOrderAttributesInfoFailure implements Action {
  readonly type = TOrderAttributesInfoActionType.GetOrderAttributesFailure;
}

export class GetOrderAttributesTypesInfo implements Action {
  readonly type = TOrderAttributesInfoActionType.GetOrderAttributesTypes;
}

export class GetOrderAttributesTypesInfoSuccess implements Action {
  readonly type = TOrderAttributesInfoActionType.GetOrderAttributesTypesSuccess;
  constructor(public OrderAttributesTypesRes: TOrderAttributeTypes[]) {}
}

export class GetOrderAttributesTypesInfoFailure implements Action {
  readonly type = TOrderAttributesInfoActionType.GetOrderAttributesTypesFailure;
}

export class AddUpdateOrderAttributes implements Action {
  readonly type = TOrderAttributesInfoActionType.AddUpdateOrderAttributes;
  constructor(
    public updateOrderAttributesPayload: TREQUEST_ADD_UPDATE_ORDER_ATTRIBUTES,
    public getOrderAttributesPayload: TREQUEST_ORDER_ATTRIBUTES,
  ) {}
}

export class AddUpdateOrderAttributesSuccess implements Action {
  readonly type = TOrderAttributesInfoActionType.AddUpdateOrderAttributesSuccess;
  constructor(public OrderAttributesRes: TRESPONSE_ORDER_ATTRIBUTES) {}
}

export class AddUpdateOrderAttributesFailure implements Action {
  readonly type = TOrderAttributesInfoActionType.AddUpdateOrderAttributesFailure;
}

export class DeleteOrderAttributes implements Action {
  readonly type = TOrderAttributesInfoActionType.DeleteOrderAttributes;
  constructor(
    public deleteOrderAttributesPayload: TREQUEST_DELETE_ORDER_ATTRIBUTES,
    public getOrderAttributesPayload: TREQUEST_ORDER_ATTRIBUTES,
  ) {}
}

export class DeleteOrderAttributesSuccess implements Action {
  readonly type = TOrderAttributesInfoActionType.DeleteOrderAttributesSuccess;
  constructor(public OrderAttributesRes: TRESPONSE_ORDER_ATTRIBUTES) {}
}

export class DeleteOrderAttributesFailure implements Action {
  readonly type = TOrderAttributesInfoActionType.DeleteOrderAttributesFailure;
}

export type TOrderAttributesActions =
  | GetOrderAttributesInfo
  | GetOrderAttributesInfoSuccess
  | GetOrderAttributesInfoFailure
  | GetOrderAttributesTypesInfo
  | GetOrderAttributesTypesInfoSuccess
  | GetOrderAttributesTypesInfoFailure
  | AddUpdateOrderAttributes
  | AddUpdateOrderAttributesSuccess
  | AddUpdateOrderAttributesFailure
  | DeleteOrderAttributes
  | DeleteOrderAttributesSuccess
  | DeleteOrderAttributesFailure;
